import { notify } from 'utils/reduxUtils';

export const types = {
  CUSTOM_PART_ATTRS_EDIT_CANCEL:
    'settings/profile/CUSTOM_PART_ATTRS_EDIT_CANCEL',
  CUSTOM_PART_ATTRS_EDIT_REQUEST:
    'settings/profile/CUSTOM_PART_ATTRS_EDIT_REQUEST',
  CUSTOM_PART_ATTRS_FETCH_SUCCESS:
    'settings/profile/CUSTOM_PART_ATTRS_FETCH_SUCCESS',
  CUSTOM_PART_ATTRS_UPDATE_ERROR:
    'settings/profile/CUSTOM_PART_ATTRS_UPDATE_ERROR',
  CUSTOM_PART_ATTRS_UPDATE_REQUEST:
    'settings/profile/CUSTOM_PART_ATTRS_UPDATE_REQUEST',
  CUSTOM_PART_ATTRS_UPDATE_SUCCESS:
    'settings/profile/CUSTOM_PART_ATTRS_UPDATE_SUCCESS',
};

export const customPartAttrsFetch = {
  success: ({ customPartAttrs }) => ({
    type: types.CUSTOM_PART_ATTRS_FETCH_SUCCESS,
    payload: { customPartAttrs },
  }),
};

export const customPartAttrsEdit = {
  request: () => ({
    type: types.CUSTOM_PART_ATTRS_EDIT_REQUEST,
  }),
  cancel: () => ({
    type: types.CUSTOM_PART_ATTRS_EDIT_CANCEL,
  }),
};

export const customPartAttrsUpdate = {
  error: notify(
    (error) => ({
      type: types.CUSTOM_PART_ATTRS_UPDATE_ERROR,
      payload: error,
    }),
    'Failed to update custom part attributes.',
  ),
  request: ({ customPartAttrs }) => ({
    type: types.CUSTOM_PART_ATTRS_UPDATE_REQUEST,
    payload: { customPartAttrs },
  }),
  success: notify(
    ({ customPartAttrs }) => ({
      type: types.CUSTOM_PART_ATTRS_UPDATE_SUCCESS,
      payload: { customPartAttrs },
    }),
    'Custom part attributes updated.',
  ),
};
